module.exports = __webpack_public_path__ + "img/tr.5389b666.svg";